export const ADMIN = 'ADMIN';
export const CLINICS = 'CLINICS';
export const ORDERS = 'ORDERS';
export const TOURNAMENTS = 'TOURNAMENTS';
export const EVENTS = 'EVENTS';
export const TRYOUTS = 'TRYOUTS';
export const TUITION = 'TUITION';
export const CHANGEPAYMENT = 'CHANGEPAYMENT';
export const SHOPEXAMPLES = 'SHOPEXAMPLES';

export const VALID_ROLES = new Set([
  ADMIN, CLINICS, ORDERS, TOURNAMENTS, EVENTS, TRYOUTS, TUITION, CHANGEPAYMENT, SHOPEXAMPLES
]);

